import axios from 'axios';
import { useMutation } from 'react-query';
import { AuthContext } from '../../Context/AuthContext';
import { useContext } from 'react';


const deleteOtherLicenses = async (token, otherLicenses) => {
  const response = await axios.delete(`${process.env.REACT_APP_SERVER_URL}/charterer/profile/delete/otherLicenses`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(otherLicenses)
  });
  return response.data;
};



export const useDeleteOtherLicenses = () => {
  const { token } = useContext(AuthContext); 

  return useMutation((otherLicenses) => deleteOtherLicenses(token, otherLicenses));
};
